module.exports = __webpack_public_path__ + "static/media/exclusive_items.180db2e3.png";